import { Box, Button, ButtonProps, Link, LinkProps, Tooltip } from "@mui/material"
import { Link as ReactRouterLink, LinkProps as ReactRouterLinkProps } from "react-router-dom"

export interface RouterSafeLinkProps extends Omit<LinkProps & ReactRouterLinkProps, "href"> {
    to: string
    newWindow?: boolean
    wrapText?: boolean
}

/**
 * We have to use this instead of the native Material-UI Link to prevent full page rerendering. using "href" is bad.
 */
const NexRouterLink = ({ newWindow, wrapText = false, sx = [], ...props }: RouterSafeLinkProps) => {
    return (
        <Link
            target={newWindow ? "_blank" : undefined}
            component={ReactRouterLink}
            sx={[wrapText && { wordBreak: "break-all" }, ...(Array.isArray(sx) ? sx : [sx])]}
            {...props}
        />
    )
}

interface ButtonLinkProps {
    to: string
    children: React.ReactNode
    disableHover?: boolean
    newWindow?: boolean
    disabled?: boolean
    tooltip?: string

    buttonProps?: ButtonProps
}

export const NexButtonLink = ({
    disabled = false,
    to,
    children,
    disableHover,
    newWindow,
    tooltip,
    buttonProps,
}: ButtonLinkProps) => {
    const ButtonWithProps = () => (
        <Tooltip title={tooltip ?? ""}>
            <Button
                sx={{
                    textAlign: "center",
                    "&:hover": { backgroundColor: disableHover ? "transparent" : undefined },
                    ...buttonProps?.sx,
                }}
                disableRipple={disableHover ? true : undefined}
                disableFocusRipple={disableHover ? true : undefined}
                disabled={disabled}
                {...buttonProps}
            >
                {children}
            </Button>
        </Tooltip>
    )

    return (
        <Box sx={buttonProps?.sx}>
            {disabled ? (
                <ButtonWithProps />
            ) : (
                <NexRouterLink to={to} target={newWindow ? "_blank" : undefined}>
                    <ButtonWithProps />
                </NexRouterLink>
            )}
        </Box>
    )
}
